import { Injectable } from '@angular/core';
import { ApiBaseService } from '@shared/services/entities/api-base.service';

/**
 * Paquetes de servicio del contrato: la lista de material que lleva un
 * procedimiento. El asistente de intervenciones (paso 3) los compara
 * contra el material cargado y sugiere el de mayor cobertura.
 */
@Injectable({ providedIn: 'root' })
export class ServicePackagesService extends ApiBaseService<any> {
  constructor() {
    super('servicepackages');
  }
}
